import type { z } from 'zod';

import type { LeadSchema } from './schemas';

type LeadField = keyof z.infer<typeof LeadSchema>;

const listAttributes = [
  'type',
  'id',
  'gradYear',
  'school',
  'schoolId',
  'schoolLabel',
  'schoolShortLabel',
  'firstName',
  'lastName',
  'parentFirstName',
  'parentLastName',
  'email',
  'phoneNumber',
  'parentEmail',
  'parentPhoneNumber',
] as const satisfies readonly LeadField[];

const getAttributes = [
  ...listAttributes,
  'creationDatetime',
  'gradYear',
  'school',
  'birthday',
  'streetAddress',
  'country',
  'postcode',
] as const satisfies readonly LeadField[];

// `schoolLabel` and `schoolShortLabel` are derived, never accepted from a caller: the
// leads entity resolves them from `schoolId` and injects them before encoding, so they
// must survive this mask
const updateAttributes = [
  'firstName',
  'lastName',
  'gradYear',
  'school',
  'schoolId',
  'schoolLabel',
  'schoolShortLabel',
  'email',
  'phoneNumber',
  'birthday',
  'parentFirstName',
  'parentLastName',
  'parentEmail',
  'parentPhoneNumber',
  'streetAddress',
  'country',
  'postcode',
] as const satisfies readonly LeadField[];

const convertAttributes = [
  'firstName',
  'lastName',
  'gradYear',
  'school',
  'schoolId',
  'email',
  'phoneNumber',
  'birthday',
  'parentFirstName',
  'parentLastName',
  'parentEmail',
  'parentPhoneNumber',
  'streetAddress',
  'country',
  'postcode',
] as const satisfies readonly LeadField[];

const requiredConvertAttributes = [
  'firstName',
  'lastName',
  'gradYear',
  'school',
  'schoolId',
  'email',
  'phoneNumber',
  'parentEmail',
  'parentPhoneNumber',
] as const satisfies readonly LeadField[];

const searchAttributes = [
  'gradYear',
  'firstName',
  'lastName',
  'parentFirstName',
  'parentLastName',
  'email',
  'phoneNumber',
  'parentEmail',
  'parentPhoneNumber',
  'school',
] as const satisfies readonly LeadField[];

export const LeadAttributes = {
  List: listAttributes,
  Get: getAttributes,
  Update: updateAttributes,
  Convert: convertAttributes,
  RequiredConvert: requiredConvertAttributes,
  Search: searchAttributes,
};
